import { Box, Stack } from "@mui/material";
import { TransactionsComponent } from "Components/Dashboard/TransactionsComponent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsMobile } from "Hooks/useIsMobile";
import { Resources, useResource } from "Translations/Resources";

export const EmployeeDashboardPage = () => {
  const isMobile = useIsMobile();
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Employee.Dashboard.Title)}
      isTitleHiddenBelowLgScreen
      isPaddingDisabled={isMobile}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <Stack mb={6} mx={isMobile ? 1 : 0} gap={isMobile ? 2 : 1}>
            <PrimaryPaper>
              <TransactionsComponent />
            </PrimaryPaper>
            <Box m={2} />
          </Stack>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default EmployeeDashboardPage;
